import React from 'react';
import styles from './RenderComponente.module.css';

export default function RenderComponent({ tipo, resultado, parametro, onConsultar }) {
  if (!resultado || !tipo || !parametro) return null;

  function handleClick(documento) {
    onConsultar(documento.trim());
  }

  // ─── CONSULTA POR TELEFONE ─────────────────────────────────────────
  function renderConsultaTelefone(resultado, telefoneConsultado) {
    const dados = resultado?.sintese?.dados;
    if (!dados || dados.length === 0) {
      return (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionIcon}>📞</span>
            <h3 className={styles.sectionTitle}>
              Pessoas associadas
            </h3>
            <span className={styles.sectionCount}>0 pessoas</span>
          </div>
          <div className={styles.emptyState}>
            <span className={styles.emptyIcon}>🔍</span>
            <p>Nenhuma pessoa encontrada vinculada a este telefone.</p>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionIcon}>📞</span>
          <h3 className={styles.sectionTitle}>
            Pessoas associadas
          </h3>
          <span className={styles.sectionCount}>
            {dados.length} pessoa{dados.length > 1 ? 's' : ''}
          </span>
        </div>

        <div className={styles.lista}>
          {dados.map((pessoa, i) => (
            <div
              key={i}
              className={styles.card}
              onClick={() => handleClick(pessoa.documento)}
              role="button"
              tabIndex={0}
            >
              <div className={styles.cardHeader}>
                <div className={styles.cardHeaderLeft}>
                  <span className={styles.cardNum}>#{i + 1}</span>
                  <h4 className={styles.cardNome}>
                    {pessoa.nome || 'Nome não disponível'}
                  </h4>
                </div>
                <div className={styles.cardHeaderRight}>
                  {pessoa.prioridade && (
                    <span
                      className={`${styles.pill} ${styles['pill' + pessoa.prioridade]}`}
                    >
                      {pessoa.prioridade}
                    </span>
                  )}
                </div>
              </div>

              <div className={styles.cardBody}>
                {pessoa.documento && (
                  <div className={styles.linha}>
                    <span className={styles.linhaLabel}>Documento</span>
                    <span className={`${styles.linhaValor} ${styles.mono}`}>
                      {pessoa.documento}
                    </span>
                  </div>
                )}

                <div className={styles.linhaGrupo}>
                  {pessoa.idade !== undefined && pessoa.idade !== null && (
                    <div className={styles.linha}>
                      <span className={styles.linhaLabel}>Idade</span>
                      <span className={styles.linhaValor}>
                        {pessoa.idade} anos
                      </span>
                    </div>
                  )}
                  {pessoa.data_formatada && (
                    <div className={styles.linha}>
                      <span className={styles.linhaLabel}>Nascimento</span>
                      <span className={styles.linhaValor}>
                        {pessoa.data_formatada}
                      </span>
                    </div>
                  )}
                </div>

                {pessoa.data && !pessoa.data_formatada && (
                  <div className={styles.linha}>
                    <span className={styles.linhaLabel}>Data</span>
                    <span className={styles.linhaValor}>{pessoa.data}</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // ─── CONSULTA POR NOME ─────────────────────────────────────────────
  function renderConsultaNome(resultado, nomeConsultado) {
    const pessoas = resultado?.sintese?.pessoa;
    if (!pessoas || pessoas.length === 0) {
      return (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionIcon}>👤</span>
            <h3 className={styles.sectionTitle}>
              Resultados do nome
            </h3>
            <span className={styles.sectionCount}>0 pessoas</span>
          </div>
          <div className={styles.emptyState}>
            <span className={styles.emptyIcon}>🔍</span>
            <p>Nenhuma pessoa encontrada com este nome.</p>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionIcon}>👤</span>
          <h3 className={styles.sectionTitle}>
            Resultados do nome
          </h3>
          <span className={styles.sectionCount}>
            {pessoas.length} pessoa{pessoas.length > 1 ? 's' : ''}
          </span>
        </div>

        <div className={styles.lista}>
          {pessoas.map((pessoa, i) => (
            <div
              key={i}
              className={styles.card}
              onClick={() => handleClick(pessoa.cpf)}
              role="button"
              tabIndex={0}
            >
              <div className={styles.cardHeader}>
                <div className={styles.cardHeaderLeft}>
                  <span className={styles.cardNum}>#{i + 1}</span>
                  <h4 className={styles.cardNome}>
                    {pessoa.nome || 'Nome não disponível'}
                  </h4>
                </div>
                <div className={styles.cardHeaderRight}>
                  {pessoa.genero && (
                    <span className={`${styles.pill} ${styles.pillGenero}`}>
                      {pessoa.genero}
                    </span>
                  )}
                </div>
              </div>

              <div className={styles.cardBody}>
                <div className={styles.linhaGrupo}>
                  {pessoa.cpf && (
                    <div className={styles.linha}>
                      <span className={styles.linhaLabel}>CPF</span>
                      <span className={`${styles.linhaValor} ${styles.mono}`}>
                        {pessoa.cpf}
                      </span>
                    </div>
                  )}
                  {pessoa.data_nascimento && (
                    <div className={styles.linha}>
                      <span className={styles.linhaLabel}>Nascimento</span>
                      <span className={styles.linhaValor}>
                        {pessoa.data_nascimento}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // ─── CONSULTA POR EMAIL ────────────────────────────────────────────
  function renderConsultaEmail(resultado, emailConsultado) {
    const dados = resultado?.sintese?.dados;
    if (!dados || dados.length === 0) {
      return (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionIcon}>📧</span>
            <h3 className={styles.sectionTitle}>
              Pessoas associadas
            </h3>
            <span className={styles.sectionCount}>0 pessoas</span>
          </div>
          <div className={styles.emptyState}>
            <span className={styles.emptyIcon}>🔍</span>
            <p>Nenhuma pessoa encontrada vinculada a este e-mail.</p>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionIcon}>📧</span>
          <h3 className={styles.sectionTitle}>
            Pessoas associadas
          </h3>
          <span className={styles.sectionCount}>
            {dados.length} pessoa{dados.length > 1 ? 's' : ''}
          </span>
        </div>

        <div className={styles.lista}>
          {dados.map((pessoa, i) => (
            <div
              key={i}
              className={styles.card}
              onClick={() => handleClick(pessoa.documento)}
              role="button"
              tabIndex={0}
            >
              <div className={styles.cardHeader}>
                <div className={styles.cardHeaderLeft}>
                  <span className={styles.cardNum}>#{i + 1}</span>
                  <h4 className={styles.cardNome}>
                    {pessoa.nome || 'Nome não disponível'}
                  </h4>
                </div>
              </div>

              <div className={styles.cardBody}>
                {pessoa.documento && (
                  <div className={styles.linha}>
                    <span className={styles.linhaLabel}>Documento</span>
                    <span className={`${styles.linhaValor} ${styles.mono}`}>
                      {pessoa.documento}
                    </span>
                  </div>
                )}

                <div className={styles.linhaGrupo}>
                  {pessoa.idade !== undefined && pessoa.idade !== null && (
                    <div className={styles.linha}>
                      <span className={styles.linhaLabel}>Idade</span>
                      <span className={styles.linhaValor}>
                        {pessoa.idade} anos
                      </span>
                    </div>
                  )}
                  {pessoa.data && (
                    <div className={styles.linha}>
                      <span className={styles.linhaLabel}>Data</span>
                      <span className={styles.linhaValor}>{pessoa.data}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // ─── CONSULTA POR CPF PARCIAL ─────────────────────────────────────────────
  function renderCpfParcial(resultado, cpfConsultado) {
    const pessoas = resultado?.sintese?.dados || [];
    if (!pessoas || pessoas.length === 0) {
      return (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <span className={styles.sectionIcon}>👤</span>
            <h3 className={styles.sectionTitle}>
              Resultados do CPF Parcial
            </h3>
            <span className={styles.sectionCount}>0 pessoas</span>
          </div>
          <div className={styles.emptyState}>
            <span className={styles.emptyIcon}>🔍</span>
            <p>Nenhuma pessoa encontrada com este CPF Parcial.</p>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionIcon}>👤</span>
          <h3 className={styles.sectionTitle}>
            Pessoas associadas
          </h3>
          <span className={styles.sectionCount}>
            {pessoas.length} pessoa{pessoas.length > 1 ? 's' : ''}
          </span>
        </div>

        <div className={styles.lista}>
          {pessoas.map((pessoa, i) => (
            <div
              key={i}
              className={styles.card}
              onClick={() => handleClick(pessoa.cpf)}
              role="button"
              tabIndex={0}
            >
              <div className={styles.cardHeader}>
                <div className={styles.cardHeaderLeft}>
                  <span className={styles.cardNum}>#{i + 1}</span>
                  <h4 className={styles.cardNome}>
                    {pessoa.nome || 'Nome não disponível'}
                  </h4>
                </div>
                <div className={styles.cardHeaderRight}>
                  {pessoa.genero && (
                    <span className={`${styles.pill} ${styles.pillGenero}`}>
                      {pessoa.genero}
                    </span>
                  )}
                </div>
              </div>

              <div className={styles.cardBody}>
                <div className={styles.linhaGrupo}>
                  {pessoa.cpf && (
                    <div className={styles.linha}>
                      <span className={styles.linhaLabel}>CPF</span>
                      <span className={`${styles.linhaValor} ${styles.mono}`}>
                        {pessoa.cpf}
                      </span>
                    </div>
                  )}
                  {pessoa.idade && (
                    <div className={styles.linha}>
                      <span className={styles.linhaLabel}>Idade</span>
                      <span className={styles.linhaValor}>
                        {pessoa.idade} Anos
                      </span>
                    </div>
                  )}
                  {pessoa.data_nascimento && (
                    <div className={styles.linha}>
                      <span className={styles.linhaLabel}>Nascimento</span>
                      <span className={styles.linhaValor}>
                        {pessoa.data_nascimento}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // ─── MAPEAMENTO E RENDERIZAÇÃO ─────────────────────────────────────
  const renderers = {
    telefone: renderConsultaTelefone,
    nome: renderConsultaNome,
    email: renderConsultaEmail,
    cpf_parcial: renderCpfParcial,
  };

  const renderer = renderers[tipo];
  if (!renderer) return null;

  // Chama a função de renderização diretamente (não como componente React)
  return renderer(resultado, parametro);
}